<template>
  <div class="calendar_wrapper row justify-content-center">
    <div class="col-xl-4 order-xl-8">
      <unavailability-helpers />
    </div>
    <div class="col-xl-8">
      <div id="spinner"><img src="../../assets/img/spinner.gif"/></div>
      <div id="calendar_month" :class="{ 'editable-calendar': true }" ></div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import UnavailabilityHelpers from '@/components/unavailabilityCalendars/UnavailabilityHelpers'
  import moment from 'moment-timezone'

  export default {
    name: 'CandidatePlanningCalendarMonthly',
    components: { UnavailabilityHelpers },
    props: ['unavailabilityDateList', 'unavailabilityDateScheduled', 'userId'],
    data() {
      return {
        calendarLibLoadDone: false,
        currentMonth: null,
        currentYear: null
      }
    },
    watch: {
      unavailabilityDateList: function (newDatesList, oldDatesList) {
        if(this.calendarLibLoadDone == true) {
          if(oldDatesList == null) {
            this.renderCalender();
          } else {
            let newEventList = this.datesToEvent(newDatesList)
            $('#calendar_month').pagescalendar('removeAllEvents')
            $('#calendar_month').pagescalendar('addEvents', newEventList)
          }
        }
      },
      unavailabilityDateScheduled: {
        handler(){
          this.addLableForDate();
        },
        deep: true
      }
    },
    computed: {
      unavailabilityDateInfo() {
        return this.unavailabilityDateScheduled["date_info"] || {}
      }
    },
    methods: {
      ...mapActions({
        loadUnavailabilityDateScheduled: 'unavailabilityDates/loadUnavailabilityDateScheduled'
      }),
      datesToEvent(dateList) {
        return dateList.map((date) => {
          return {
            title: date['id'],
            class: 'readonly',
            start: date['start_at'],
            end: date['end_at']
          }
        })
      },
      clickDateAction(){
        let self = this
        $('[data-date]').on('click', function() {
          let selectedDate = moment(this.getAttribute("data-date"), 'YYYY-MM-DD').format(self.$i18n.t('format.date'));
          self.$emit('updateDateRange', selectedDate, selectedDate);
        });
      },
      renderCalender(){
        if(this.unavailabilityDateList == null) return ;
        let self = this
        $('#spinner').hide();
        $('#calendar_month').show();
        $('#calendar_month').pagescalendar({
          ui: {
            year: {
              visible: true,
              format: 'YYYY',
              startYear: '2017',
              endYear: moment().add(8, 'year').format('YYYY'),
              eventBubble: true
            },
            dateHeader: {
              format: 'dddd D MMMM YYYY',
              visible: true,
            }
          },
          view: 'month',
          locale: 'fr',
          onViewRenderComplete: function() {
            self.clickDateAction();
            self.addLableForDate();
          },
          onDateChange: function(range){
            self.$emit('updateDateRange', range["start"].format(self.$i18n.t('format.date')), range["end"].format(self.$i18n.t('format.date')));
            self.reloadUnavailabilityDateScheduled(range)
            $('html').css('cursor', 'initial')
          }
        });
      },
      reloadUnavailabilityDateScheduled(range) {
        this.loadUnavailabilityDateScheduled({
          user_id: this.userId,
          start_date: range["start"].format(this.$i18n.t('format.date')),
          end_date: range["end"].format(this.$i18n.t('format.date'))
        })
      },
      addLableForDate() {
        let self = this;
        $(".unavailability-dates--all, .unavailability-dates--part, .unavailability-dates--night-shift").remove()
        $('.month-date').removeClass('text-white')
        $('[data-date]').each(function(){
          let info = self.unavailabilityDateInfo[this.getAttribute("data-date")] || {}
          let type = info["type"]
          let providers = info["unavailability_dates_providers"]
          let dateClass = ""

          if(type && type !== "empty") {
            if(type === "unavailable_full_time") {
              $(this).find('.month-date').addClass('text-white')
              dateClass = "unavailability-dates--all"
            } else if(type === "unavailable_night_shift") {
              dateClass = "unavailability-dates--night-shift"
            } else {
              dateClass = "unavailability-dates--part"
            }
            let dateCellHtml = `<div class="${dateClass}">`
            providers.forEach(function(provider){
              dateCellHtml += `<div class="${provider}"></div>`
            })
            dateCellHtml += '</div>'
            $(this).find('.cell-inner').append(dateCellHtml)
          }
        })
      },
    },
    mounted: function(){
      var self = this;
      $('#calendar_month').hide();
      this.currentMonth = moment().format(this.$i18n.t('format.month'))
      this.currentYear = moment().format(this.$i18n.t('format.year'))
      if($('#calendarJsLib')[0] != undefined) {
        self.calendarLibLoadDone = true
        self.renderCalender();
        return;
      }
      let script_tag = document.createElement('script');
      script_tag.src = window.location.origin + '/static/assets/js/pages.calendar.js';
      script_tag.id = 'calendarJsLib';
      document.head.appendChild(script_tag);
      var script = document.querySelector('#calendarJsLib');
      script.addEventListener('load', function() {
        self.calendarLibLoadDone = true;
        self.renderCalender();
      });
    }
  }
</script>
<style scoped lang="scss">
  .calendar_wrapper {
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/CandidatePlanningCalendarMonthly.vue